import { AppActions } from "../../action";
import { SET_ANSI_AUDIT_LOG, SET_ANSI_COMMITTEE_LIST, SET_ANSI_SELECTED_COMMITTEE, SET_ANSI_SELECTED_STANDARD, SET_ANSI_STANDARD_LIST, SET_ANSI_TAB_INDEX, SET_SELECTED_COMMITTEE , SET_BSR108_DATA, SET_ANSI_DELETE_FLOW, SET_ALL_ANSI_COMMITTEE_LIST, SET_PINS_REPORTS_DATA, SET_BSR_DELETE_FLOW, SET_BSR109_DATA} from "../../action-type";

const initialState = {
  ansiCommitteeData: [],
  ansiStandardData: [],
  bsr108Data: null,
  bsr109Data: null,
  PINSReports:null,
  selectedAnsiCommittee: "",
  ansiDeleteFlow: null,
  ansiStandardToDelete: null,
  ansiCommitteeToDelete: null,
  allAnsiCommitteeData:[]
};

type actionsType = AppActions;

const ansiReducer = (state: any = initialState, action: actionsType): any => {
  switch (action.type) {
    case SET_ANSI_COMMITTEE_LIST:
      return {
        ...state,
        ansiCommitteeData: action.data || [],
      };
    case SET_ANSI_STANDARD_LIST:
      return {
        ...state,
        ansiStandardData: action.data || [],
      };
    case SET_ANSI_SELECTED_COMMITTEE:
      return {
        ...state,
        ansiSelectedCommittee: action.data || [],
      };
    case SET_ANSI_SELECTED_STANDARD:
      return {
        ...state,
        ansiSelectedStandard: action.data || 0,
      };
    case SET_ANSI_TAB_INDEX:
      return {
        ...state,
        ansiTabIndex: action.data || 0,
      };
     case SET_BSR108_DATA:    
            return {
                ...state,
                bsr108Data: action.data,
            };
     case SET_BSR109_DATA:    
            return {
                ...state,
                bsr109Data: action.data,
            };       
    case SET_SELECTED_COMMITTEE:
      return {
        ...state,
        selectedAnsiCommittee: action.data || "",
      };
    case SET_ANSI_AUDIT_LOG:
      return {
        ...state,
        ansiAuditLog: action.data || {},
      };
    case SET_ANSI_DELETE_FLOW:
      return {
        ...state,
        ansiDeleteFlow: action.data?.flow || null,
        ansiStandardToDelete: action.data?.standard ? {...action.data.standard} : null,
        ansiCommitteeToDelete: action.data?.committee || null,
      };
    case SET_PINS_REPORTS_DATA:    
            return {
                ...state,
                PINSReports: action.data,
            };
    case SET_ALL_ANSI_COMMITTEE_LIST:
      return {
        ...state,
        allAnsiCommitteeData: action.data || [],
      };
    case SET_BSR_DELETE_FLOW:
      return {
        ...state,
        bsr108DeleteFlow: action.data?.flow || null,
        bsr108fileNameToDelete: action.data?.filename || null,
        bsr108fileToDelete : action.data?.fileToDelete
      };
    default:
      return state;
  }
};

export default ansiReducer;